// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import constants from "@store/constants";
import OrderHeader from "@store/Library/Components/Toolkit/Order/OrderHeader";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import React, { FC, useContext } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const RequestOrderComplaintHeader: FC<Props> = ({ id, pageTitle }) => {
    const { value: order } = useContext(OrderStateContext);
    const linkBack = usePageLinkByPageType(`${constants.pageType.orderDetails}`);
    return (
        <OrderHeader
            title={pageTitle}
            linkBack={linkBack}
            pageIdSegment={`?orderNumber=${order?.webOrderNumber || order?.erpOrderNumber}`}
        ></OrderHeader>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, null)(RequestOrderComplaintHeader),
    definition: {
        displayName: "Page Header",
        allowedContexts: ["OrderComplaintPage" as any],
        fieldDefinitions: [],
        group: constants.widgetGroup.orderComplaint,
    },
};

export default widgetModule;
